module.exports = __webpack_public_path__ + "static/media/SVGyourstory.bea8998c.svg";